export default "__VITE_ASSET__D3JbzAE3__"